import React from 'react';

export const API_ERRORS_HANDLED = Symbol('API_ERRORS_HANDLED');

// TODO complete garbage - remove asap
export const toastApiErrors = async (promise, enqueueSnackbar)=>{
    try {
        return await promise;
    } catch (e) {
        console.log(e);
        if (e.code!='validation_error')
            enqueueSnackbar(e.code ? e.message : 'אירעה שגיאה, נסו שוב מאוחר יותר', {variant: 'error'});
        else
            enqueueSnackbar(e.extra.map(c=>c.message).join('. '), {variant: 'error'});
        return API_ERRORS_HANDLED;
    }
};
